import React, { useState } from "react";
import "./bankHeader.css";

import { FaPlusCircle } from "react-icons/fa";

const BankHeader = ({ onAddBankClicked, onSearchBank }) => {
  const [searchValue, setSearchValue] = useState(
    localStorage.getItem("searchValue")
  );
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
    if (errorMessage && e.target.value >= 3) {
      setErrorMessage("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      localStorage.setItem("searchValue", searchValue);
      e.preventDefault();
      if (searchValue.length > 2) {
        onSearchBank(searchValue);
        setErrorMessage("");
      } else if (searchValue.length === 0) {
        onSearchBank(searchValue);
        setErrorMessage("");
      } else {
        setErrorMessage("Pencarian membutuhkan minimal lebih dari 3 huruf");
      }
    }
  };

  return (
    <div className="bank-header-container">
      <button className="add-bank-button" onClick={onAddBankClicked}>
        <FaPlusCircle />
        Tambah Bank Baru
      </button>

      <div className="search-container">
        <input
          type="text"
          placeholder="Cari Bank"
          className="search-input"
          value={searchValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
    </div>
  );
};

export default BankHeader;
